<template>
    <div>
        <nav-bar :key="2"></nav-bar>
        <div class="content">
            <nav-left-bar :active="0" :key="2"></nav-left-bar>
            <div class="rg">
                <div class="tit">
                    <div class="l">
                        <img src="../../assets/icon/bg.png" alt="" />
                        <div class="tc">会议室信息管理</div>
                    </div>
                    <div class="block">
                        <el-cascader
                            v-model="organValue"
                            :options="options"
                            @change="handleChange"
                            placeholder="组织结构"
                            :props="props"
                        ></el-cascader>
                    </div>
                    <div class="search">
                        <el-input
                            placeholder="请输入会议室名称"
                            v-model="keyword"
                            clearable
                        >
                            <i
                                slot="prefix"
                                class="el-input__icon el-icon-search"
                            ></i>
                        </el-input>
                        <el-button class="search-btn" @click="onSearch"
                            >搜索</el-button
                        >
                    </div>
                </div>
                <div class="list">
                    <div style="height:50px;"></div>
                    <div class="sh">
                        <el-table :data="tableData" border style="width: 100%">
                            <el-table-column
                                v-for="(item, index) in listData"
                                :key="index"
                                :prop="item.prop"
                                :label="item.label"
                                :width="item.width"
                            >
                            </el-table-column>
                        </el-table>
                    </div>
                    <div style="height:50px;"></div>
                    <el-pagination
                        background
                        layout="prev, pager, next"
                        :total="total"
                        :page-size="8"
                        @current-change="currentPage"
                        @prev-click="prev"
                        @next-click="next"
                    >
                    </el-pagination>
                    <div style="height:50px;"></div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
let id = 0;
export default {
    name: "room_inform",
    data() {
        return {
            page: 1,
            limit: 8,
            sourceList: [],
            keyword: "",
            show: false,
            organList: [],
            organValue: [],
            props: {
                value: "id",
                label: "name",
                checkStrictly: true
            },
            options: [],
            listData: [
                { prop: "no", label: "会议室编号", width: "110" },
                { prop: "section_name", label: "会议室归属", width: "200" },
                { prop: "name", label: "会议室名称", width: "140" },
                {
                    prop: "address",
                    label: "会议室门牌",
                    width: "100"
                },
                { prop: "manager_name", label: "会议室管理员", width: "110" },
                { prop: "manager_mobile", label: "管理员手机", width: "110" },
                { prop: "content", label: "简介", width: "700" },
            ],
            tableData: [],
            total: 0
        };
    },
    methods: {
        clear() {
            this.value = "";
        },
        select(e) {
            this.$router.push({
                path: "/appointmentDetails",
                query: {
                    id: e
                }
            });
        },
        onSearch() {
            this.list();
        },
        list() {
            let params = {
                page: this.page,
                limit: this.limit,
                keyword: this.keyword,
                section_id:
                    this.organValue.length == 0
                        ? ""
                        : this.organValue[this.organValue.length - 1]
            };
            this.$post("/api/meeting/assets_meeting_list", params)
                .then(res => {
                    if (res.code == 1) {
                        this.tableData = res.data.data;
                        this.total = res.data.count;
                        if (res.data.data.length < this.limit) {
                            // this.show = true;
                        }
                    }
                })
                .catch(err => {
                    console.log(err);
                });
        },
        currentPage(e) {
            this.page = e;
            this.list();
        },
        next(e) {
            this.page = e;
            this.list();
        },
        prev(e) {
            this.page = e;
            this.list();
        },
        handleChange(value){
            this.list();
        },
        /**组织架构选择 */
        handleChanges() {
            this.$post("/api/Meeting/dept_list", {
               
            })
                .then(res => {
                    if (res.code == 1) {
                        this.options = res.data;
                    }
                })
                .catch(err => {});
        }
    },
    mounted() {
        this.list();
        this.handleChanges();
    }
};
</script>
<style lang="less">
.el-table th > .cell {
    text-align: center;
}
.el-table .cell {
    text-align: center;
}
.el-table--enable-row-transition .el-table__body td {
    text-align: center;
}
</style>
<style lang="less" scoped>
.content {
    max-width: 1200px;
    margin: 0 auto;
    margin-top: 21px;
    display: flex;
    .rg {
        width: 838px;
        height: 80px;
        // line-height: 80px;
        background: #ffffff;
        margin-left: 21px;
        .tit {
            width: 100%;
            height: 100%;
            display: flex;
            align-items: center;
            justify-content: space-between;
            .l {
                display: flex;
                height: 100%;
                align-items: center;
                margin-right: 10px;
                img {
                    width: 5px;
                    height: 24px;
                }
                .tc {
                    font-size: 24px;
                    font-family: PingFangSC, PingFangSC-Medium;
                    font-weight: 500;
                    color: #333333;
                    padding-left: 13px;
                }
            }
            .search {
                // width: 346px;
                // height: 35px;
                // background: #f5f5f5;
                // border-radius: 2px;
                display: flex;
                .search-btn {
                    margin: 0 15px;
                }
            }
        }
        .list {
            width: 838px;
            background: #ffffff;
            margin-top: 21px;
            .sh {
                flex: 1;
                margin: 0 20px;
            }
        }
    }
}
.el-cascader {
    width: 130px;
}
</style>
